import { useState } from 'react'
import { Btn, Input, Textarea, Field, Toggle, Modal } from '../../../components/ui/design.jsx'

export default function ImageTypeModal({ type, onClose, onSave }) {
  const isNew = !type
  const [form, setForm] = useState({
    slug:        type?.slug        || '',
    name:        type?.name        || '',
    description: type?.description || '',
    max_active:  type?.max_active  ?? '',
    sort_order:  type?.sort_order  ?? 0,
    is_active:   type?.is_active   ?? true,
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    onSave({
      isNew,
      id: type?.id,
      payload: {
        ...form,
        max_active:  form.max_active === '' ? null : Number(form.max_active),
        sort_order:  Number(form.sort_order || 0),
      },
    })
  }

  return (
    <Modal onClose={onClose} title={isNew ? 'Tambah Tipe Gambar' : `Edit “${type.name}”`}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Field label="Nama tipe" req>
          <Input
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="cth: Hero Background"
          />
        </Field>

        <Field label={isNew ? 'Kode tipe' : 'Kode tipe (tidak bisa diubah)'} req={isNew}>
          <Input
            required
            disabled={!isNew}
            value={form.slug}
            onChange={(e) => setForm({ ...form, slug: e.target.value })}
            pattern="^[a-z0-9_]+$"
            placeholder="cth: hero_background"
            className={!isNew ? 'opacity-50 font-mono' : 'font-mono'}
          />
        </Field>

        <Field label="Keterangan">
          <Textarea
            rows={2}
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            placeholder="Penjelasan singkat"
          />
        </Field>

        <div className="grid grid-cols-2 gap-4">
          <Field label="Maks. aktif (kosong = tidak terbatas)">
            <Input
              type="number" min={1}
              value={form.max_active}
              onChange={(e) => setForm({ ...form, max_active: e.target.value })}
              placeholder="cth: 4"
            />
          </Field>
          <Field label="Urutan tampil">
            <Input
              type="number" min={0}
              value={form.sort_order}
              onChange={(e) => setForm({ ...form, sort_order: e.target.value })}
            />
          </Field>
        </div>

        <div className="flex items-center gap-2.5">
          <Toggle checked={form.is_active} onChange={(v) => setForm({ ...form, is_active: v })} />
          <span className="text-sm text-gray-700">Slot aktif</span>
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <Btn type="button" variant="secondary" onClick={onClose}>Batal</Btn>
          <Btn type="submit">Simpan</Btn>
        </div>
      </form>
    </Modal>
  )
}
